import React from 'react';
import { Image } from 'antd';

import { createAssetUrl } from 'common/utils/http';

interface Props {
  attributeId?: number;
}

const PreviewPictureAttribute = ({ attributeId }: Props) => {
  const imgSrc = attributeId ? createAssetUrl(attributeId) : '';
  return (<Image src={imgSrc} width={100} />
  );
};

export default PreviewPictureAttribute;
